import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from '@core/broadcaster/broadcaster.service';
import { Area } from '@core/area';
import { LandModalConfig } from './LandModalConfig';

@Injectable()
export class OpenLandModalEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(key: string, land: Area): void {
    let config = new LandModalConfig();

    config.key = key;
    config.land = land;

    this.broadcaster.broadcast(OpenLandModalEvent, config);
  }

  on(): Observable<LandModalConfig> {
    return this.broadcaster.on<LandModalConfig>(OpenLandModalEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/events/OpenLandModalEvent.ts